import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { XIcon } from '@phosphor-icons/react';

interface BaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

export const BaseModal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  maxWidth = 'md',
}: BaseModalProps) => {
  if (!isOpen) return null;

  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
  };

  const modalContent = (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
      <div className="absolute inset-0 bg-black bg-opacity-50 z-0" onClick={onClose} />

      <div
        className={`relative bg-white rounded-lg shadow-xl w-full ${maxWidthClasses[maxWidth]} flex flex-col max-h-[calc(100vh-5rem)] z-10`}
      >
        <div className="flex items-center justify-between p-6 border-b border-gray-200 flex-shrink-0">
          <h2 className="text-2xl font-display text-primary">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition">
            <XIcon size={24} />
          </button>
        </div>

        <div className="flex flex-1 min-h-0 flex-col overflow-y-auto p-6">{children}</div>

        {footer && <div className="p-6 border-t border-gray-200 flex-shrink-0">{footer}</div>}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};
